import(/* webpackMode: "eager" */ "/vercel/path1/app/(core)/error.tsx");
